module.exports = __webpack_public_path__ + "img/body-boxes-symptoms.c130279b.png";